import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../../../utilities/classNames";

var BlockQuote = function BlockQuote(_ref) {
  var attribution = _ref.attribution,
      cite = _ref.cite,
      quotemark = _ref.quotemark,
      small = _ref.small,
      text = _ref.text;
  var getClassName = getClassNameFactory("LongformBlockQuote");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames({
        quotemark: quotemark,
        small: small
      })
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, /*#__PURE__*/React.createElement("blockquote", {
    className: getClassName({
      descendantName: "quote"
    }),
    cite: cite
  }, text)), attribution ? /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "attribution"
    })
  }, attribution) : null);
};

BlockQuote.propTypes = {
  /**
   * Attribution component for attributing the quotation
   */
  attribution: PropTypes.node,

  /**
   * URL that designates source document or message for the information quoted.
   */
  cite: PropTypes.string,

  /**
   * Show the decorative quotemark
   */
  quotemark: PropTypes.bool.isRequired,

  /**
   * Optional small variant
   */
  small: PropTypes.bool,

  /**
   * The quotation
   */
  text: PropTypes.string.isRequired
};
BlockQuote.defaultProps = {
  quotemark: true,
  small: false
};
BlockQuote.displayName = "Longform.BlockQuote";
export default BlockQuote;